import { makeAutoObservable } from 'mobx';
import _ from 'lodash';
import FieldViewModel from './FieldViewModel';

class FieldSectionViewModel {
  data;
  report;
  checked = false;
  fields = [];

  constructor(data, report) {
    makeAutoObservable(this);

    this.data = data;
    this.report = report;

    this.fields = this.data.values.map(v => new FieldViewModel(v, report));
    this.checked = !!_.find(this.fields, { checked: true });
  }

  toggleAllChecked() {
    this.checked = !this.checked;
    for (const f of this.fields) {
      f.checked = this.checked;
    }
  }

  updateField(field, value) {
    if (field === 'employmentRecordsShowHistory') {
      this.report.merge({employmentRecordsShowHistory: value});
    }
  }

  toggleFieldChecked(fieldViewModel) {
    fieldViewModel.toggleChecked();
    this.checked = !(this.checkedFieldCount === 0);
  }

  get middleIndex() {
    return parseInt(this.data.values.length / 2) + (this.data.values.length % 2);
  }

  get firstHalf() {
    return this.fields.slice(0, this.middleIndex);
  }

  get secondHalf() {
    return this.fields.slice(this.middleIndex);
  }

  get checkedFieldCount() {
    return _.filter(this.fields, { checked: true }).length;
  }
}

export default FieldSectionViewModel;
